import {ValidationRules} from "@/Shared/form-validations";
import {i18n} from "@/i18n";

export const TITLE_MAX_LENGTH = 100;
export const TITLE_MIN_LENGTH = 5;

const TitleValidations = new ValidationRules({
    required: v => !!v || i18n.t('bibles.validations.title.required'),
    valid_string: v => String.isString(v) || i18n.t('bibles.validations.title.valid_string'),
    min: v => v.trim().length > TITLE_MIN_LENGTH || i18n.t('bibles.validations.title.min_length', {value: TITLE_MIN_LENGTH}),
    max: v => v.trim().length <= TITLE_MAX_LENGTH || i18n.t('bibles.validations.title.max_length', {value: TITLE_MAX_LENGTH}),
});

const AcademicPeriodValidations = new ValidationRules({
    required: v => !!v || i18n.t('bibles.validations.academic_period.required'),
});

const DataTypeValidations = new ValidationRules({
    required: v => !!v || i18n.t('bibles.validations.data_type.required'),
});

const DataStrategyValidations = new ValidationRules({
    required: v => !!v || i18n.t('bibles.validations.data_strategy.required'),
});

const ModeValidations = new ValidationRules({
    required: v => !!v || i18n.t('bibles.validations.mode.required'),
});

export {
    TitleValidations,
    AcademicPeriodValidations,
    DataTypeValidations,
    DataStrategyValidations,
    ModeValidations,
}
